import Vue from 'vue'

Vue.component('Loading', () => import ('./modules/shared/Loading.vue'))
Vue.component('Form', () => import ('./modules/shared/Form.vue'))
Vue.component('FormInput', () => import ('./modules/shared/FormInput.vue'))
